import React from 'react';
import { timezones } from '../../../utils/timezones';
import Button from '../../../shared/Button';
import SiteLink from '../../../shared/SiteLink';
import ConfirmationDialog from '../../Modals/ConfirmationDialog';
import DialogContentText from '@mui/material/DialogContentText/DialogContentText';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import UpgradeDialog from '../../Modals/UpgradeDialog';
import EmailValidationServiceAddOnDialog from '../../Modals/EmailValidationServiceAddOnDialog';
import { Checkbox, FormControlLabel } from '@mui/material';
import Tooltips from '../../Tooltips';

const SITE_URL_FORMAT = /^(https?:\/\/)?([a-z0-9_-]+\.)+[a-z]{2,}(:\d+)?([/?#]\S*)?$/i;

class SiteForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFree: props.site.plan.free || props.site.plan.free_forever,
      shouldBuyEmailValidationCredits:
        !this.isFree && props.site.validate_email_credit === 0,
      id: props.site.id,
      url: props.site.url,
      timezone: props.site.timezone,
      opted_in_to_email_digest: props.site.opted_in_to_email_digest,
      gaEnabled: props.site.ga_enabled,
      validateEmail: props.site.validate_email,
      modalQueueEnabled: props.site.modal_queue_enabled || false,
      spamShieldEnabled: props.site.spam_shield_enabled || false,
      showUpgradedModal: false,
      urlError: '',
    };
    this.onSubmit = props.onSubmit.bind(this);
    this.onSiteDelete = props.onSiteDelete.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDeleteSite = this.handleDeleteSite.bind(this);
    this.gaEnableChange = this.gaEnableChange.bind(this);
    this.handleValidateEmail = this.handleValidateEmail.bind(this);
    this.handleSpamShieldEnabled = this.handleSpamShieldEnabled.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  gaEnableChange(event) {
    this.state.isFree
      ? this.setState({
          showUpgradedModal: true,
        })
      : this.setState({
          gaEnabled: event.target.checked,
        });
  }

  // handleValidateEmail() {
  //   this.setState({
  //     validateEmail: !this.state.validateEmail,
  //   });
  // }

  handleValidateEmail = () => {
    this.state.isFree
      ? this.setState({
          showUpgradedModal: true,
        })
      : this.state.shouldBuyEmailValidationCredits
      ? this.setState({
          showValidationAddOnModal: true,
        })
      : this.setState({
          validateEmail: !this.state.validateEmail,
        });
  };

  handleSpamShieldEnabled() {
    const { spam_shield_managed, spam_shield_self_serve_eligible } = this.props.site?.capabilities || {};
    if (this.state.isFree) {
      this.setState({ showUpgradedModal: true });
    } else if (!spam_shield_managed && !spam_shield_self_serve_eligible) {
      // ineligible (PayPal or custom plan) — checkbox is disabled so this shouldn't fire,
      // but guard here as well
    } else {
      this.setState({ spamShieldEnabled: !this.state.spamShieldEnabled });
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    const urlChanged = this.state.url !== this.props.site?.url;
    if (urlChanged && !SITE_URL_FORMAT.test((this.state.url || '').trim())) {
      this.setState({ urlError: 'Enter a valid website address, like example.com' });
      return;
    }
    this.setState({ loading: true });
    const wasSpamShieldEnabled = this.props.site?.spam_shield_enabled;
    const wasUrl = this.props.site?.url;
    this.onSubmit({
      id: this.state.id,
      url: this.state.url,
      timezone: this.state.timezone,
      opted_in_to_email_digest: this.state.opted_in_to_email_digest,
      ga_enabled: this.state.gaEnabled ? 1 : 0,
      validate_email: this.state.validateEmail,
      modal_queue_enabled: this.state.modalQueueEnabled,
      spam_shield_enabled: this.state.spamShieldEnabled,
    }).then((updated) => {
      this.setState({ loading: false });
      if (!updated) return;
      if (updated.urlError) {
        this.setState({ urlError: updated.urlError });
        return;
      }
      // If server rolled back spam_shield (e.g. Stripe error), sync UI state to reality
      if (updated && updated.spam_shield_enabled !== undefined) {
        this.setState({ spamShieldEnabled: !!updated.spam_shield_enabled });
      }
      try {
        if (this.state.spamShieldEnabled && !wasSpamShieldEnabled) {
          window.analytics?.track('Spam Shield Enabled', { site_id: this.state.id });
        } else if (!this.state.spamShieldEnabled && wasSpamShieldEnabled) {
          window.analytics?.track('Spam Shield Disabled', { site_id: this.state.id });
        }
        if (this.state.url !== wasUrl) {
          window.analytics?.track('Site URL Updated', { site_id: this.state.id, new_url: this.state.url });
        }
      } catch (_) {}
    });
  }

  handleModalQueueEnabled = () => {
    this.setState({
      modalQueueEnabled: !this.state.modalQueueEnabled,
    });
  };

  handleDeleteSite() {
    return this.onSiteDelete(this.state.id);
  }

  render() {
    return (
      <>
        {this.state.showUpgradedModal && (
          <UpgradeDialog
            onClose={() => this.setState({ showUpgradedModal: false })}
          />
        )}
        {this.state.showValidationAddOnModal && (
          <EmailValidationServiceAddOnDialog
            site={this.props.site}
            isOpen={true}
          />
        )}
        <form onSubmit={this.handleSubmit}>
          <Grid>
            <Grid
              container
              justifyContent="flex-start"
              className="inputs"
              spacing={3}
            >
              <Grid item xs={12}>
                <Grid container spacing={6}>
                  <Grid item xs={3}>
                    <FormControl fullWidth className="UrlInput">
                      <TextField
                        required
                        value={this.state.url}
                        onChange={(e) => {
                          this.setState({ urlError: '' });
                          this.handleInputChange(e);
                        }}
                        error={!!this.state.urlError}
                        helperText={
                          this.state.urlError ||
                          (this.state.url !== this.props.site?.url
                            ? 'Hello Bar only runs on this exact address. After changing it, make sure the script is installed on the new site.'
                            : '')
                        }
                        FormHelperTextProps={
                          !this.state.urlError && this.state.url !== this.props.site?.url
                            ? { style: { color: '#b26a00' } }
                            : undefined
                        }
                        name="url"
                        label="URL"
                        size="small"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={3}>
                    <FormControl fullWidth className="TimezoneInput">
                      <TextField
                        select
                        label="Timezone"
                        required
                        value={this.state.timezone}
                        onChange={this.handleInputChange}
                        name="timezone"
                        size="small"
                      >
                        {timezones.map(({ title, id }) => (
                          <MenuItem key={id} value={id}>
                            {title}
                          </MenuItem>
                        ))}
                      </TextField>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.gaEnabled}
                          onChange={this.gaEnableChange}
                          size="small"
                        />
                      }
                      label="Send Popup events to Google Analytics"
                    />
                    <Tooltips
                      icon={true}
                      title="Send Popup events to Google Analytics"
                      url="https://support.hellobar.com/support/solutions/articles/44002395028-how-to-sync-your-hello-bar-popup-views-and-conversion-to-google-analytics-ga4-"
                      message="For better visibility and tracking we will send any popup View/Click/Conversion event on your site to your installed Google Analytics property."
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.modalQueueEnabled}
                          onChange={this.handleModalQueueEnabled}
                          size="small"
                        />
                      }
                      label="Show only one modal popup at a time"
                    />
                    <Tooltips
                      icon={true}
                      message="When enabled, only one modal popup will display per page load. If multiple popups are eligible, only the first one will show."
                    />
                  </Grid>
                </Grid>
              </Grid>
              {this.props.site?.capabilities?.spam_shield && !this.state.isFree && (
                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={12}>
                      {(() => {
                        const isManaged = !!this.props.site?.capabilities?.spam_shield_managed;
                        const isEligible = !!this.props.site?.capabilities?.spam_shield_self_serve_eligible;
                        const isDisabled = isManaged || !isEligible;
                        const label = isManaged
                          ? 'Spam Shield Protection (Managed)'
                          : isEligible
                          ? 'Enable Spam Shield Protection ($15/mo)'
                          : 'Spam Shield Protection';
                        return (
                          <>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={this.state.spamShieldEnabled}
                                  onChange={this.handleSpamShieldEnabled}
                                  size="small"
                                  disabled={isDisabled}
                                />
                              }
                              label={label}
                            />
                            <Tooltips
                              icon={true}
                              message="Protect your forms from spam bots and fake leads. Only real, verified submissions reach your ESP."
                            />
                            {isManaged && (
                              <div style={{ marginTop: '6px', fontSize: '12px', color: '#6b7280', fontStyle: 'italic' }}>
                                Spam Shield is managed by the HelloBar team for your account. Contact support to make changes.
                              </div>
                            )}
                            {!isManaged && !isEligible && (
                              <div style={{ marginTop: '6px', fontSize: '12px', color: '#6b7280', fontStyle: 'italic' }}>
                                Please contact our support team to enable Spam Shield for your account.
                              </div>
                            )}
                          </>
                        );
                      })()}
{this.state.spamShieldEnabled && !this.props.site?.spam_shield_enabled && (
                        <div style={{
                          marginTop: '8px',
                          marginBottom: '8px',
                          padding: '14px 16px',
                          backgroundColor: '#fef3c7',
                          borderLeft: '4px solid #f59e0b',
                          borderRadius: '4px',
                          color: '#78350f',
                          fontSize: '12.5px',
                          lineHeight: '1.8',
                          maxWidth: '480px'
                        }}>
                          <div style={{ marginBottom: '8px' }}>
                            <strong>What is Spam Shield?</strong><br />
                            Automatically filters bots, fake leads, and low-quality submissions — so your contact list stays clean and your team only follows up with real people.
                          </div>
                          <div style={{ marginBottom: '6px' }}><strong>What you get for $15.00/mo:</strong></div>
                          ✓ Every form submission scored for spam in real-time<br />
                          ✓ Fake and disposable emails flagged automatically<br />
                          ✓ Spam submissions automatically blocked before reaching your ESP<br />
                          ✓ {this.props.site?.capabilities?.spam_shield_free_quota || 50} deep email verifications included per billing cycle<br />
                          <div style={{ marginTop: '8px', fontSize: '12px', color: '#92400e' }}>
                            Extra deep email verifications beyond {this.props.site?.capabilities?.spam_shield_free_quota || 50} are charged at $0.01 each at the end of your billing cycle.
                          </div>
                          <div style={{ marginTop: '10px', fontSize: '12px', color: '#78350f', borderTop: '1px solid #fcd34d', paddingTop: '8px' }}>
                            💡 You can disable deep email verification anytime to avoid extra charges, and adjust the spam score threshold to control how strictly submissions are filtered — both available in site settings after enabling.
                          </div>
                        </div>
                      )}
                      {!this.state.spamShieldEnabled && this.props.site?.spam_shield_enabled && (
                        <div style={{
                          marginTop: '8px',
                          marginBottom: '8px',
                          padding: '12px 16px',
                          backgroundColor: '#fee2e2',
                          borderLeft: '4px solid #ef4444',
                          borderRadius: '4px',
                          color: '#7f1d1d',
                          fontSize: '12.5px',
                          lineHeight: '1.5',
                          maxWidth: '480px'
                        }}>
                          <strong>Notice:</strong> Disabling Spam Shield will stop protection immediately. Your subscription will remain active until the end of the current billing cycle to collect any pending email verification charges, then automatically cancel.
                        </div>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              )}
              {this.props.site?.opted_in_to_email_digest && (
                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={12}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.validateEmail}
                            id="site_validate_email"
                            onChange={this.handleValidateEmail}
                          />
                        }
                        label="Validate email deliverability to ensure a clean email list"
                      />
                      <Tooltips
                        icon={true}
                        message="We'll validate the deliverabity of the email entered in the lead form by your visitor and add the results in the contact list"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={12}>
                    <div className="button-wrapper">
                      <SiteLink to="/install">
                        Installation instructions
                      </SiteLink>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <footer>
            <Button
              type="submit"
              loading={this.state.loading}
              color="secondary"
              label="Save &amp; Update"
            />{' '}
            &nbsp;&nbsp;
            <ConfirmationDialog
              onConfirm={this.handleDeleteSite}
              buttonColor="primary"
              buttonTitle="Delete Site"
            >
              <DialogContentText>
                Historical data will be deleted and you will not be able to
                recover it after this. Are you sure you wish to delete this
                site?
              </DialogContentText>
            </ConfirmationDialog>
          </footer>
        </form>
      </>
    );
  }
}

export default SiteForm;
